/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function whenReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  // Only claim `openCart` when the theme renders its own drawer. Under
  // `cart_type: page` the cart belongs to a third-party app, and hijacking the
  // action would navigate to /cart instead of letting that app open its cart.
  whenReady(() => {
    if (!document.querySelector('theme-drawer#cart-drawer')) return;

    actions.openCart.configure({
      async handler() {
        /** @type {HTMLElement & {open?: () => void} | null} */
        const drawer = document.querySelector('theme-drawer#cart-drawer');

        if (drawer?.open) {
          drawer.open();
        } else {
          window.location.href = Theme.routes.cart_url || '/cart';
        }
      },
    });
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
